export class ConfigService {
  static getConfig(key: string) {
    return process.env[key];
  }
}
